import { useLocation } from 'react-router-dom';
import { IndustrialCompanyScale, IcxRegion } from '@generated/graphql';
import {
  IndustrialComplexNameForFrontEnd,
  IndustrialSectorsCategoryForFrontEnd,
  IndustrialSectorsNameForFrontEnd
} from '@components/SearchFilterPopper/type';

const useFilterList = (
  query: any
): { category: string; values: string[] }[] => {
  const { pathname } = useLocation();

  if (pathname.includes('industry')) {
    return [
      {
        category: FilterList.Region,
        values: query[FilterList.ComplexName] ? [] : Object.values(IcxRegion)
      },
      {
        category: FilterList.ComplexName,
        values: query[FilterList.Region]
          ? []
          : Object.values(IndustrialComplexNameForFrontEnd)
      },
      {
        category: FilterList.SectorsCategory,
        values: Object.values(IndustrialSectorsCategoryForFrontEnd)
      },
      {
        category: FilterList.SectorsName,
        values: Object.values(IndustrialSectorsNameForFrontEnd)
      },
      {
        category: FilterList.CompanyScale,
        values: Object.values(IndustrialCompanyScale)
      }
    ];
  }
  return [];
};

export default useFilterList;

export enum FilterList {
  Region = '지역',
  ComplexName = '단지',
  SectorsCategory = '제조업',
  SectorsName = '업종',
  CompanyScale = '회사 규모'
}
